export default __webpack_public_path__ + "static/media/fileerror.942922e4.gif";